import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Collapse, Container, Grid } from "@material-ui/core";
import Imagen from "./Imagen";

export const Team = (props) => {
  let history = useHistory();
  const [open, setOpen] = useState({});
  const [detalles, setDetalles] = useState({});

  let irA = (to) => {
    history.push(to);
  };

  let handleCollapse = (cat) => {
    if (cat.id === open.id) {
      setOpen({});
      setDetalles({});
    } else {
      setOpen(cat);
      setDetalles({});
    }
  };

  let handleCollapsePaquete = (paq) => {
    if (paq.id === detalles.id) {
      setDetalles({});
    } else {
      setDetalles(paq);
    }
  };

  return (
    <Container id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>{props.data ? props.data.title : "loading"}</h2>
          <p>{props.data ? props.data.paragraph : "loading"}</p>
        </div>
        <div id="row">
          {props.data
            ? props.categorias.map((cat) => (
                <a
                  id="service"
                  href={open.categoria ? "#collapse" : "#service"}
                  onClick={() => handleCollapse(cat)}
                  key={`${cat.id}`}
                  className="col-md-6 col-sm-12 team"
                >
                  <div className="thumbnail">
                    {" "}
                    <Imagen folder="team" docName={cat.docName} />
                    <div className="caption">
                      <h4>{cat.categoria}</h4>
                      <p>{cat.job}</p>
                    </div>
                  </div>
                </a>
              ))
            : "loading"}
        </div>
      </div>
      <div id="collapse">
        <Collapse
          in={open.categoria}
          timeout={{ appear: 1000, enter: 2000, exit: 2000 }}
        >
          {open.subcategorias &&
            open.subcategorias.map((sub) =>
              sub.paquetes.length > 0 ? (
                <Grid container className="caption" id={sub.id} key={sub.id}>
                  <Grid xs={12}>
                    <h3 style={{ textAlign: "left", paddingLeft: "10%" }}>
                      {sub.subcategoria}
                    </h3>
                    <div className="col-md-6 col-sm-12 team">
                      <div className="thumbnail">
                        {" "}
                        <Imagen folder="subcategorias" docName={sub.docName} />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 team">
                      <p style={{ textAlign: 'left'}}>{sub.descripcion}</p>
                    </div>
                  </Grid>
                  {sub.paquetes && sub.ver ?
                    sub.paquetes.map((paq) => (
                      <Grid
                        xs={12}
                        md={
                          sub.paquetes.length === 1
                            ? 12
                            : sub.paquetes.length === 2
                            ? 6
                            : 4
                        }
                        id="paquete"
                        key={paq.id}
                        className="team"
                        onClick={() => handleCollapsePaquete(paq)}
                      >
                        <div className="thumbnail">
                          <div className="caption">
                            <h4>{paq.paquete}</h4>
                          </div>
                        </div>
                      </Grid>
                    )) : null}
                  <Collapse
                    in={detalles.idSubcategoria === sub.id}
                    timeout="auto"
                  >
                    <Grid
                      xs={12}
                      style={{ paddingLeft: "35px" }}
                      className="caption"
                    >
                      <h3 style={{ paddingLeft: "20px" }}>
                        {detalles.paquete}
                      </h3>
                      {detalles.moneda ? (
                        <p>{`$ ${
                          detalles.precio &&
                          detalles.precio.toLocaleString("de-DE")
                        }`}</p>
                      ) : (
                        <p>{`U$S ${
                          detalles.precio &&
                          detalles.precio.toLocaleString("de-DE")
                        }`}</p>
                      )}
                      <p style={{ textAlign: 'left'}}>{detalles.descripcion}</p>
                    </Grid>
                  </Collapse>
                </Grid>
              ) : null
            )}
        </Collapse>
      </div>
    </Container>
  );
};
